import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change } from 'redux-form'
import compose from 'recompose/compose'

import translate from '@/i18n/translate'
import { goToPage as goToPageAction } from '@/state/actions/routes'
import { crudCreate as crudCreateAction } from '@/state/actions/data'

import { Card } from '@/ui/Card'
import { Container, Row, Column, Cell, Flex } from '@/ui/Element'
import Button from '@/ui/Button/Button'

import { InputField, ImageInput } from '@/ui/Input'
import ImageField from '@/ui/Data/ImageField'

class newProduct extends Component {
  renderImage = props => (
    <ImageInput
      {...props}
      theme={this.props.theme}
      source="image"
      label="Image"
      accept="image/*"
      placeholder={<p>Drop your image here</p>}
    >
      <ImageField source="src" title="title" theme={this.props.theme} />
    </ImageInput>
  )

  saveProduct = record => {
    this.props.crudCreate('products', record, false, {
      message: `${record.title || this.props.initialValues.title} created.`,
    })
  }

  goBack = () => {
    this.props.dispatch(this.props.goToPage(this.props.currentRouteData.parent))
  }

  render() {
    const {
      theme,
      handleSubmit,
      submitting,
      data = {},
      // translate,
      //  ...rest
    } = this.props

    return (
      <Container>
        <Column>
          <form className="form product" onSubmit={handleSubmit(this.saveProduct)}>
            <Cell>
              <Card classes={['v-padding-large', 'colored-card']}>
                <Row gutter="large">
                  <Cell size="50">
                    <Field
                      name="vendor"
                      labelText="Vendor:"
                      component={InputField}
                      placeholder="Vendor name"
                      id="vendor"
                      value={data.vendor}
                    />
                    <Field
                      name="title"
                      labelText="Product:"
                      component={InputField}
                      placeholder="Product"
                      id="title"
                      value={data.title}
                    />
                    <div style={{ position: 'relative' }}>
                      <Field
                        name="color"
                        labelText="Color:"
                        component={InputField}
                        placeholder="Default color (HEX value)"
                        id="color"
                        onFocus={this.handleClick}
                        value={data.color}
                      />
                      <div
                        className={theme['color-field']}
                        style={{ background: `#${data.color}` }}
                      />
                    </div>
                    <Field
                      name="abbrevetation"
                      labelText="Abbrevetation:"
                      component={InputField}
                      placeholder="Abbrevetation (two letters)"
                      id="abbrevetation"
                    />
                    <Field
                      name="url"
                      labelText="Url:"
                      component={InputField}
                      style={{ marginBottom: 0 }}
                      placeholder="Product url"
                      id="url"
                    />
                  </Cell>
                  <Cell size="50" dir="vertical">
                    <span className={theme['product-logo-label']}>Product logo</span>
                    <Field
                      name="logo"
                      component={this.renderImage}
                      classes={`${theme['drop-wrapper']} ${theme['flex-cell']}`}
                      id="logo"
                    />
                  </Cell>
                </Row>
              </Card>
            </Cell>
            <Flex horz="right" classes={['top-margin']}>
              <Button
                theme={theme}
                styles="right-margin"
                disabled={submitting}
                onClick={this.goBack}
              >
                Cancel
              </Button>
              <Button
                theme={theme}
                type="submit"
                classes={['secondary']}
                styles="h-padding-large"
                disabled={submitting}
              >
                Save
              </Button>
            </Flex>
          </form>
        </Column>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    isLoading: state.rest.loading > 0,
    data: (state.form.newProduct && state.form.newProduct.values) || {},
  }
}

const enhance = compose(
  connect(mapStateToProps, {
    goToPage: goToPageAction,
    crudCreate: crudCreateAction,
    change: change,
  }),
  translate,
  reduxForm({
    form: 'newProduct',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      ;['vendor', 'title', 'color', 'abbrevetation'].forEach(field => {
        if (!values[field]) errors[field] = translate('i18n.validation.required')
      })
      return errors
    },
  }),
)

export default enhance(newProduct)



// WEBPACK FOOTER //
// ./view/Products/newProduct.js